
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/templates",
      function () {
        return require("private-next-pages/[locale]/templates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/templates"])
      });
    }
  